import { forwardRef } from "react";
import styles from "./SocialShareBox.scss";
import SocialShareLinks from "./SocialShareLinks";

const SocialShareBox = forwardRef((_, ref) => {
  return (
    <div ref={ref} className={styles.socialShareBoxWrapper}>
      <SocialShareLinks />
    </div>
  );
});

SocialShareBox.displayName = "SocialShareBar";

export default SocialShareBox;
